import React, { MouseEvent } from 'react';
import styled from '@emotion/styled';
import { InfoIcon, ITheme } from '../../../../../../ui';
import { useTranslation } from '../../../../../shared/i18n/translate/useTranslation';
import { setHash } from '../../../../../shared/router/hash/hashHistory';
import { IParkingProduct } from '../../../../domain/parking-product/models/IParkingProduct';
import { Color } from '../../../../../shared/styles/Color';
import themed from '../../../../../../ui/themer/themed';

export const StyledShowDetailsButton = styled.button<{}, ITheme>`
	appearance: none;
	background: none;
	border: none;
	cursor: pointer;
	padding: 8px;

	svg {
		width: 22px;
		height: 22px;
		border-radius: 100%;
		box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
	}

	&:hover {
		svg {
			box-shadow: 0 2px 4px 0 ${themed(({ color }) => color.highlight)};
		}
	}

	&:focus-visible {
		outline: none;

		svg {
			outline: 3px solid ${Color.PrimaryDefault};
		}
	}
`;

export interface IShowDetailsButtonProps {
	parkingProduct: IParkingProduct;
	variation?: 'inverted' | 'highlight';
}

export const ShowDetailsButton = ({
	parkingProduct,
	variation,
}: IShowDetailsButtonProps) => {
	const { t } = useTranslation();

	const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
		e.stopPropagation();
		setHash(`#details/${parkingProduct.id}`, { replace: true });
	};

	const label = t('web_parking_availability_results_info_button_label', {
		parking_product_name: parkingProduct.name,
	});

	return (
		<StyledShowDetailsButton
			aria-label={label}
			title={label}
			onClick={handleClick}
		>
			<InfoIcon variation={variation ?? 'inverted'} aria-hidden="true" />
		</StyledShowDetailsButton>
	);
};
